import { useEffect } from 'react'

export const useScrollListener = (callback: () => void, enabled = true) => {
  useEffect(() => {
    if (enabled) {
      const handleScroll = callback

      // Listen to scroll events on grid and window
      const gridElement = document.querySelector('.ag-body-viewport')
      gridElement?.addEventListener('scroll', handleScroll)
      window.addEventListener('scroll', handleScroll)

      return () => {
        gridElement?.removeEventListener('scroll', handleScroll)
        window.removeEventListener('scroll', handleScroll)
      }
    }

    return () => {}
  }, [callback, enabled])
}
